import { render, staticRenderFns } from "./CarouselPage.vue?vue&type=template&id=023d59dd&scoped=true&"
import script from "./CarouselPage.vue?vue&type=script&lang=js&"
export * from "./CarouselPage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPage.vue?vue&type=style&index=0&id=023d59dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d59dd",
  null
  
)

export default component.exports